import Image from "next/image";

/**
 * Foto del boot con fallback al gradiente de la tarjeta (rediseño 2026).
 * Úsalo dentro de un contenedor con tamaño/overflow definidos.
 */
export function FotoBoot({
  imagen,
  gradiente,
  alt,
  className = "",
  sizes = "170px",
}: {
  imagen: string;
  gradiente: string;
  alt: string;
  className?: string;
  sizes?: string;
}) {
  if (!imagen) {
    return (
      <span
        aria-hidden
        className={`block h-full w-full ${className}`}
        style={{ background: gradiente }}
      />
    );
  }
  return (
    <span className={`relative block h-full w-full ${className}`}>
      <Image src={imagen} alt={alt} fill sizes={sizes} className="object-cover" />
    </span>
  );
}
